<template lang='pug'>
//- Question-Detail-Page
div(:class='$style[`cc-question`]')
  div(v-if='!preloading' :class='$style[`cc-question-main`]')
    div(:class='$style[`cc-question-switcher`]')
      router-link(
        role='button'
        tabindex='0'
        aria-label='返回討論板列表'
        :to='{ name: `feature-type`, params: { type: `qa` }}'
        :title='`返回討論板列表`'
        :class='$style[`cc-question-switcher-prev`]')
        IconOpenArrow(:size='20' :color='`#6f6f6f`')
        != '返回列表'
    div(:class='$style[`cc-banner-title`]')
      div(v-if='quesData.user_type === `doctor`' :class='$style[`cc-banner-avatar`]')
        //- div(:class='$style[`cc-avatar-public`]') {{ `公開帳號` }}
        router-link(
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-banner-avatar-wrap`]'
          :to='{ name: `profile-detail`, params: { type: `doctor`, id: `${quesData.author_id}` }}')
          figure(v-if='quesData.thumbSrc === ``' :class='$style[`cc-avatar-photo`]')
            //- Doctor-Male-Avatar
            div(:class='$style[`cc-avatar-mask`]')
              span!= '查看'
            img(
              v-if='quesData.gender === `0`'
              :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
              width='100%'
              height='100%')
            //- Doctor-Female-Avatar
            img(
              v-else
              :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
              width='100%'
              height='100%')
          figure(v-else :class='$style[`cc-avatar-photo`]')
            img(
              :src='avatarSrcLink(quesData.thumbSrc)'
              width='100%'
              height='100%')
          span.font-medium.font-doctor-theme(:class='$style[`cc-avatar-name`]') {{ `${quesData.firstName}${quesData.lastName}` }}

        div(v-if='quesData.author_id === `${loginDjangoId}`' :class='$style[`cc-avatar-controller`]')
          div(:class='$style[`cc-avatar-controller-btn`]' @click='handleAuthorClickUpdateAsk')
            IconEdit(:size='16' :color='`#b1b1b1`')
            span!= '編輯'
          div(:class='$style[`cc-avatar-controller-btn`]' @click='handleAuthorClickDeleteAsk')
            IconDelete(:size='16' :color='`#b1b1b1`')
            span!= '移除'

        //- div(:class='$style[`cc-avatar-bookmark`]')
        //-   transition(name='ani-bookmark-slide-down')
        //-     figure.bookmark-icon(v-if='showBookmarkIcon' :class='[`bookmark-icon-doctor`, $style[`cc-qa-bookmark-icon`]]')


      div(v-if='quesData.user_type === `normal`' :class='$style[`cc-banner-avatar`]')
        //- div(:class='$style[`cc-avatar-public`]') {{ quesData.public === `yes` ? `公開帳號` : `匿名帳號` }}
        router-link(
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-banner-avatar-wrap`]'
          :to='{ name: `profile-detail`, params: { type: `normal`, id: `${quesData.author_id}` }}')
          figure(v-if='quesData.thumbSrc === `` && !quesData.public' :class='$style[`cc-avatar-photo`]')
            div(:class='$style[`cc-avatar-mask`]')
              span!= '查看'
            img(
              v-if='quesData.gender === `0`'
              :src='`${STATIC_URL}images/common/user/normal_male.webp`'
              width='100%'
              height='100%')
            img(
              v-else
              :src='`${STATIC_URL}images/common/user/normal_female.webp`'
              width='100%'
              height='100%')

          figure(v-else-if='quesData.thumbSrc !== `` && !quesData.public' :class='$style[`cc-avatar-photo`]')
            div(:class='$style[`cc-avatar-mask`]')
              span!= '查看'
            img(
              v-if='quesData.gender === `0`'
              :src='`${STATIC_URL}images/common/user/normal_male.webp`'
              width='100%'
              height='100%')
            img(
              v-else
              :src='`${STATIC_URL}images/common/user/normal_female.webp`'
              width='100%'
              height='100%')


          figure(v-else-if='quesData.thumbSrc === `` && quesData.public' :class='$style[`cc-avatar-photo`]')
            div(:class='$style[`cc-avatar-mask`]')
              span!= '查看'
            img(
              v-if='quesData.gender === `0`'
              :src='`${STATIC_URL}images/common/user/normal_male.webp`'
              width='100%'
              height='100%')
            img(
              v-else
              :src='`${STATIC_URL}images/common/user/normal_female.webp`'
              width='100%'
              height='100%')

          figure(v-else-if='quesData.thumbSrc !== `` && quesData.public' :class='$style[`cc-avatar-photo`]')
            div(:class='$style[`cc-avatar-mask`]')
              span!= '查看'
            img(
              :src='avatarSrcLink(quesData.thumbSrc)'
              width='100%'
              height='100%')

          span.font-medium.font-normal-theme(
            v-if='quesData.public'
            :class='$style[`cc-avatar-name`]') {{ `${quesData.firstName}${quesData.lastName}` }}
          span.font-medium.font-normal-theme(
            v-else
            :class='$style[`cc-avatar-name`]') {{ `${quesData.firstName}${quesData.gender === `0` ? `先生` : `小姐`}` }}

        div(v-if='quesData.author_id === `${loginDjangoId}`' :class='$style[`cc-avatar-controller`]')
          div(:class='$style[`cc-avatar-controller-btn`]' @click='handleAuthorClickUpdateAsk')
            IconEdit(:size='16' :color='`#b1b1b1`')
            span!= '編輯'
          div(:class='$style[`cc-avatar-controller-btn`]' @click='handleAuthorClickDeleteAsk')
            IconDelete(:size='16' :color='`#b1b1b1`')
            span!= '移除'

        //- div(:class='$style[`cc-avatar-bookmark`]')
        //-   transition(name='ani-bookmark-slide-down')
        //-     figure.bookmark-icon(v-if='showBookmarkIcon' :class='[`bookmark-icon-normal`, $style[`cc-qa-bookmark-icon`]]')


      div(:class='$style[`cc-banner-info`]')
        span.font-medium(
          :title='`問題：${quesData.title}`'
          :class='$style[`cc-info-title`]') {{ quesData.title }}
        div(:class='$style[`cc-info-status`]')
          span {{ quesData.date }}
          span {{ quesData.tag }}
        div(:class='$style[`cc-info-panel`]')
          QuestionPanel(
            :qid='quesData.id'
            :key='`${nextTick}-p`'
            :totalAgree='checkDataTotalCount(quesData.agree)'
            :totalLike='checkDataTotalCount(quesData.like)')

        //- span(:class='[$style[`cc-info-describe`], $style[needCollapse ? `` : `cc-closed`]]') {{ ellipseQaDescribe(quesData.describe) }}
        span(v-if='needCollapse' :class='$style[`cc-info-describe`]') {{ ellipseQaDescribe(quesData.describe) }}
        span(v-else :class='$style[`cc-info-describe`]') {{ quesData.describe }}

        span(v-if='needCollapse' :class='$style[`cc-info-collapse`]' @click='handleClickOpenCollapse')
          IconOpenArrow(:size='12' :color='`#6f6f6f`')
          != '展開內容'
        QuestionReactor(
          :qid='`${quesData.id}`'
          :authorId='`${quesData.author_id}`'
          :isBookmarked='checkIfDataMatched(quesData.addBookmark)'
          :isAgree='checkIfDataMatched(quesData.agree)'
          :isLike='checkIfDataMatched(quesData.like)'
          @sendBookmarkState='checkBookmarkStateFromChild'
          @sendAgreeLikeState='checkAgreeLikeStateFromChild')


    //- 留言撰寫區
    div(v-if='loginStatus' :class='$style[`cc-question-message`]')
      TextAreaer(
        v-model='qaConfig.infoValue'
        title='留言...'
        :key='`${nextTick}-t`'
        :autoSize='true'
        :class='$style[`cc-input-textarea`]'
        :defaultValue='qaConfig.infoValue'
        :emojiButton='true'
        :resetButton='false'
        :placehold='`留言...`'
        :errorValue='checkEmptyStatus.infoError'
        @clearErrorMsg='(value) => {this.checkEmptyStatus.infoError = value[0];}')
      div(:class='$style[`cc-question-message-controller`]')
        CheckBox(
          v-model='qaConfig.readRuleValue'
          title='我會遵守規範'
          :errorValue='checkEmptyStatus.readRuleError'
          :labelText='`<a href="${NODE_DOMAIN}/termUsage" target="_blank" rel="noreferrer" title="我會遵守規範">遵守規範</a>`'
          @sendCheckStatus='setRuleCheckBoxStatus'
          @clearErrorMsg="(value) => {this.checkEmptyStatus.readRuleError = value}")

        button(
          tabindex='0'
          aria-label='送出'
          :class='$style[`cc-question-controller-send`]'
          @click='handleCheckProgressBeforeSend') 送出
        button(
          tabindex='0'
          aria-label='清除'
          :class='$style[`cc-question-controller-reset`]'
          @click='handleClickClearTextArea') 清除

    //- 留言清單區
    div(:class='$style[`cc-question-reply`]')
      div(:class='$style[`cc-question-reply-total`]')
        span.font-medium() {{ `留言(${totalReplyCount})` }}
      div(v-if='totalReplyCount === 0' :class='$style[`cc-question-reply-info`]')
        span!= '尚無留言'
      ul(:class='$style[`cc-question-reply-ul`]')
        li(v-for='items, index in replyData' :key='index' :class='$style[`cc-question-reply-li`]')
          QuestionReply(:replyData='items' :qId='items.q_id' :authorId='quesData.author_id')

      div(v-if='loadedComplete && !firstLoadEmpty' :class='$style[`cc-record-wrap`]')
        infinite-loading(:class='$style[`cc-content-infinite-load`]' :identifier='infiniteId' @infinite='infiniteHandler')
          IconLoading(slot='spinner' :size='30' :color='`#b1b1b1`')
          div.infinite-scroll-slot(slot='no-more')
            span.infinite-scroll-slot-noMore {{ '沒有更多留言' }}

          div.infinite-scroll-slot(slot='no-results')
            span.infinite-scroll-slot-noMore {{ '沒有更多留言' }}


  //- Preloader Container
  div(v-else :class='$style[`cc-preloader-content`]')
    div(:class='$style[`cc-banner-title`]')
      div(:class='$style[`cc-banner-avatar`]')
        div.skeleton-preload(:class='$style[`cc-banner-photo`]')
      div(:class='$style[`cc-banner-info`]')
        div.skeleton-preload(:class='$style[`cc-banner-info-name`]')
        div.skeleton-preload(:class='$style[`cc-banner-info-sub1`]')
        div.skeleton-preload(:class='$style[`cc-banner-info-sub2`]')


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
// import { debounce } from 'debounce';
import QuestionPanel from './QuestionPanel';
import QuestionReactor from './QuestionReactor';
import QuestionReply from './QuestionReply';
import TextAreaer from '../common/TextArea';
import CheckBox from '../common/Checkbox';

import IconEmoji from '../../icon/Emoji';
import IconOpenArrow from '../../icon/OpenArrow';
import IconEdit from '../../icon/Edit';
import IconLoading from '../../icon/Loading';
import IconDelete from '../../icon/Delete';

import {
  getCurrentDate,
  postCreateNewNotify,

  putQaReplyList,
  postCreateQaReply,
  getQaLoadStatus,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: `${this.quesData.title}`,
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: `https://cancell.tw/qa/${this.quesData.id}`,
      }],
      link: [{
        rel: 'canonical',
        href: `https://cancell.tw/qa/${this.quesData.id}`,
      }],
    };
  },

  components: {
    QuestionPanel,
    QuestionReactor,
    QuestionReply,
    TextAreaer,
    CheckBox,
    IconEmoji,
    IconOpenArrow,
    IconEdit,
    IconDelete,
    IconLoading,
  },

  mixins: [clickaway],

  props: {
    quesId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      preloading: true,
      showLoading: false,
      loadedComplete: false,
      firstLoadEmpty: false,
      needCollapse: false,
      showBookmarkIcon: false,
      showEmoji: false,

      totalReplyCount: 0,

      qaConfig: {
        infoValue: '',
        infoError: false,
        readRuleError: false,
      },

      checkEmptyStatus: {
        infoError: false,
        readRuleError: false,
      },
      verifyAllPass: true,

      limitCount: 8,
      pageIndex: 1,
      quesData: {},
      replyData: [],
      nextTick: 1,
      updateTick: 1,

      infiniteId: +new Date(),
    };
  },

  created() {
    this.axiosLoadQuestionStatus();
    this.axiosLoadReplyData();
  },

  // mounted() {},

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopDeleteAskStatus: 'global/POPDELETE_ASK_STATUS',
      changePopQuestionStatus: 'global/POPQUESTION_STATUS',
    }),

    infiniteHandler($state) {
      if (this.loadedComplete) {
        // this.loadedPreload = true;

        const PASS_DATA = {
          size: `${this.limitCount}`,
          page: `${this.pageIndex}`,
          q_id: `${this.$route.params.quesId}`,
        };

        putQaReplyList('', PASS_DATA)
          .then((res) => {
            const resData = res.data.results;
            if (!resData.length) {
              // this.loadedPreload = false;
              $state.complete();
              return;
            }

            const getLoadData = new Promise((resolve) => {
              resData.forEach((element) => {
                this.replyData.push(element);
              });
              return resolve(resData.length);
            });

            getLoadData.then((value) => {
              if (value >= this.limitCount) {
                this.pageIndex += 1;
                // this.loadedPreload = false;
                $state.loaded();
              } else {
                // this.loadedPreload = false;
                $state.complete();
              }
            });
            // const replyRes = res.data;
            // this.totalReplyCount = replyRes.count;
            // this.replyData = replyRes.results;
          })
          .catch((err) => {
            console.log('infiniteHandler Error');
          });
      } else {
        // this.loadedPreload = false;
        $state.complete();
      }
    },

    createNewNotifyEvent(category, eventType) {
      if (`${this.loginDjangoId}` === `${this.quesData.author_id}`) {
        console.log('偵測到Remind是同個人!!');
        return;
      }
      getCurrentDate('')
        .then((res) => {
          const POST_DATA = {
            auth_id: `${this.loginDjangoId}`,
            category,
            category_id: `${this.quesId}`,
            remind_user_id: `${this.quesData.author_id}`,
            remind: 'yes',
            date: `${res.data}`,
            behavior: eventType,
          };

          postCreateNewNotify('', POST_DATA)
            .then((res) => {
              console.log('建立通知成功!!');
            })
            .catch((err) => {
              console.log('建立通知失敗!!');
            });
        })
        .catch((err) => {});
    },

    handleClickOpenCollapse() {
      this.needCollapse = false;
    },

    handleClickClearTextArea() {
      this.qaConfig.infoValue = '';
      this.nextTick += 1;
    },

    ellipseQaDescribe(text) {
      if (text.length > 60) {
        this.needCollapse = true;
        return `${text.substring(0, 60)}...`;
      }
      return text;
    },

    setRuleCheckBoxStatus(value) {
      // eslint-disable-next-line no-unused-expressions
      value === 'checked' ? this.qaConfig.readRuleValue = true : this.qaConfig.readRuleValue = false;
    },

    checkIfDataMatched(recieveData) {
      // console.log('CheckData', recieveData);
      return recieveData.includes(`${this.loginDjangoId}`);
    },

    checkDataTotalCount(recieveData) {
      return recieveData.includes(`${this.loginDjangoId}`) ? recieveData.length : recieveData.length;
    },

    checkBookMarkStateOnLoad(dataBookMark) {
      // if (this.isPreload) { return; }
      this.showBookmarkIcon = dataBookMark.includes(`${this.loginDjangoId}`);
    },

    checkBookmarkStateFromChild(value) {
      this.showBookmarkIcon = value;
      this.nextTick += 1;
    },

    checkAgreeLikeStateFromChild(value) {
      getQaLoadStatus(`/?qid=${this.quesId}`)
        .then((res) => {
          const quesRes = res.data.results[0];
          this.quesData = quesRes;
        })
        .catch((err) => {
          console.log('Axios getQaLoadStatus Error');
        });
    },

    handleAuthorClickDeleteAsk() {
      this.changePopDeleteAskStatus({
        active: true,
        qid: `${this.quesId}`,
      });
    },

    handleAuthorClickUpdateAsk() {
      this.changePopQuestionStatus({
        active: true,
        qid: `${this.quesId}`,
        feature: 'update',
      });
    },

    axiosLoadQuestionStatus() {
      getQaLoadStatus(`/?qid=${this.quesId}`)
        .then((res) => {
          if (!res.data.results) {
            this.$router.replace({
              name: 'error404',
            }).catch(() => true);
            console.log('查無這則提問');
            return;
          }
          const quesRes = res.data.results[0];
          this.quesData = quesRes;
          this.preloading = false;
          // this.totalReplyCount = replyRes.count;
          this.ellipseQaDescribe(this.quesData.describe);
          this.checkBookMarkStateOnLoad(quesRes.addBookmark);
        })
        .catch((err) => {
          console.log('Axios getQaLoadStatus Error', err.response.status);
          if (err.response.status === 500) {
            this.$router.replace({
              name: 'error404',
            }).catch(() => true);
          }
        });
    },

    axiosLoadReplyData() {
      this.pageIndex = 1;
      this.loadedComplete = false;
      this.firstLoadEmpty = false;

      const PASS_DATA = {
        size: `${this.limitCount}`,
        page: `${this.pageIndex}`,
        q_id: `${this.$route.params.quesId}`,
      };

      putQaReplyList('', PASS_DATA)
        .then((res) => {
          const replyRes = res.data;
          this.totalReplyCount = replyRes.count;

          const getLoadData = new Promise((resolve) => {
            replyRes.results.forEach((element) => {
              this.replyData.push(element);
            });
            return resolve(this.replyData.length);
          });

          getLoadData.then((value) => {
            this.loadedComplete = true;
            this.infiniteId += 1;
            this.pageIndex += 1;

            if (value === 0) {
              console.log('Load Qa Empty');
              this.firstLoadEmpty = true;
            }
          });
        })
        .catch((err) => {
          console.log('AxiosLoadReplyData Error');
        });
    },

    axiosCreateNewReply() {
      getCurrentDate('')
        .then((res) => {
          const PASS_DATA = {
            qid: `${this.$route.params.quesId}`,
            auth_id: `${this.loginDjangoId}`,
            reply: `${this.qaConfig.infoValue}`,
            date: `${res.data}`,
          };
          // const jwtAccess = JSON.parse(this.authJwtToken).a;

          postCreateQaReply('', PASS_DATA, {
            headers: {
              'content-Type': 'application/json',
              // Authorization: `Bearer ${jwtAccess}`,
            },
          })
            .then((res) => {
              console.log('新增留言成功!');
              this.qaConfig.infoValue = '';
              this.changePopBoxStatus({
                active: true,
                include: 'sendConfirm',
              });

              this.createNewNotifyEvent('qa', 'qa-reply');
              this.handleUserAddHp(this.loginDjangoId, '+20');

              setTimeout(() => {
                this.changePopBoxStatus({
                  active: false,
                  include: '',
                });
              }, this.POP_DURATION);

              this.nextTick += 1;
              this.updateTick += 1;
            })
            .catch((err) => {
              console.log('Axios postCreateQaReply Error');
            });
        })
        .catch((err) => {
          console.log('Axios getCurrentDate Error');
        });
    },

    handleFormCheckToPass() {
      // this.verifyAllPass = this.$options.data().verifyAllPass;
      this.verifyAllPass = true;

      if (!this.qaConfig.infoValue) {
        this.checkEmptyStatus.infoError = true;
        this.verifyAllPass = false;
      }

      if (!this.qaConfig.readRuleValue) {
        this.checkEmptyStatus.readRuleError = true;
        this.verifyAllPass = false;
      }
    },

    handleConnectDjangoWithApi() {
      if (!this.verifyAllPass) {
        return;
      }

      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
        return;
      }

      this.showLoading = true;
      this.axiosCreateNewReply();
    },

    async handleCheckProgressBeforeSend() {
      await this.handleFormCheckToPass();
      await this.handleConnectDjangoWithApi();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  watch: {
    updateTick() {
      this.replyData = [];
      this.axiosLoadReplyData();
    },

    $route(to, from) {
      if (to.name === 'qa-detail') {
        this.axiosLoadQuestionStatus();
        this.axiosLoadReplyData();
      }
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/qa/question.scss';
</style>
